import { AnnotationLink } from './AnnotationLink';
import { AnnotationLinkCollection } from './AnnotationLinkCollection';
import type { AnnotationLinkJSON, DBPath, ModelId, ViewModelId } from 'balus-common';
import { RTDBPath } from 'balus-common';
import { RecordRepository, RefBuilder } from '@framework/repository';

export class AnnotationLinkRepository {
  private readonly path: DBPath;
  private readonly repository: RecordRepository<AnnotationLinkJSON, AnnotationLink>;

  constructor(viewModelId: ViewModelId, modelId: ModelId) {
    this.path = RTDBPath.AnnotationLink.linksPath(viewModelId, modelId);
    this.repository = new RecordRepository(AnnotationLink, this.path);
  }

  async saveContents(links: AnnotationLinkCollection): Promise<void> {
    await this.repository.save(links.toRecord());
  }

  async loadContents(): Promise<AnnotationLinkCollection> {
    const snapshot = await RefBuilder.ref(this.path).once('value');
    const values: Record<string, AnnotationLinkJSON> = snapshot.val() ?? {};
    return AnnotationLinkCollection.load(Object.values(values));
  }
}
